var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "stories-slider-container" },
    [
      _vm.stories.length > 0
        ? _c(
            "flickity-slider",
            {
              ref: "slider",
              staticClass: "stories-slider",
              attrs: { options: _vm.sliderOptions }
            },
            _vm._l(_vm.stories, function(story, index) {
              return _c(
                "div",
                { key: "story-" + story.id, staticClass: "carousel-cell" },
                [
                  _c("div", { staticClass: "inner-slide" }, [
                    _c("div", { staticClass: "slide-image" }, [
                      _c(
                        "a",
                        { attrs: { href: "#/post/" + _vm.urlTitle(story) } },
                        [
                          _c("img", {
                            attrs: {
                              src: "https://api.everwondr.com" + story.source
                            }
                          })
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "slide-content" }, [
                      _c("div", { staticClass: "slide-box" }, [
                        _c(
                          "a",
                          {
                            staticClass: "slide-body",
                            attrs: { href: "#/post/" + _vm.urlTitle(story) }
                          },
                          [
                            _c("h4", [
                              _c("span", [
                                _vm._v(
                                  "STORY .0" +
                                    _vm._s(_vm.getPadded(index + 1, 2))
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "h3",
                              {
                                directives: [
                                  {
                                    name: "balance-text",
                                    rawName: "v-balance-text.children",
                                    modifiers: { children: true }
                                  }
                                ]
                              },
                              [
                                _c("div", {
                                  domProps: { innerHTML: _vm._s(story.title) }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c("p", {
                              staticClass: "body-copy",
                              domProps: { innerHTML: _vm._s(story.summary) }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "author-name" }, [
                          _c("i", { staticClass: "fas fa-blog" }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "BY " +
                                _vm._s(story.first_name) +
                                " " +
                                _vm._s(story.last_name)
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
                ]
              )
            }),
            0
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-svg-inline-loader/dist/index.min.js?{}!./scripts/components/LocalStoriesMast.vue?vue&type=template&id=77750a9b&
// module id = 433
// module chunks = 0